module.exports = __webpack_public_path__ + "static/media/D_A.77309f17.png";